export default "<p>company-tools works!</p>\r\n";